"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareOnTwitter = exports.ShareOnLinkedin = exports.ShareOnGmail = exports.ShareOnFacebook = void 0;
var _react = _interopRequireDefault(require("react"));
var InvalidLink = function InvalidLink() {
  return /*#__PURE__*/_react["default"].createElement("p", {
    "data-testid": "invalid-link-message"
  }, "Error: Please provide valid link");
};
var ShareOnFacebook = function ShareOnFacebook(props) {
  var link = props.link;
  return link ? /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "facebook-share",
    className: props.className,
    rel: "noreferrer",
    target: "_blank",
    href: "http://www.facebook.com/share.php?u=".concat(link)
  }, props.children || 'Share on Facebook') : /*#__PURE__*/_react["default"].createElement(InvalidLink, null);
};
exports.ShareOnFacebook = ShareOnFacebook;
var ShareOnLinkedin = function ShareOnLinkedin(props) {
  var link = props.link;
  return link ? /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "linkedin-share",
    className: props.className,
    rel: "noreferrer",
    target: "_blank",
    href: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(link)
  }, props.children || 'Share on Linkedin') : /*#__PURE__*/_react["default"].createElement(InvalidLink, null);
};
exports.ShareOnLinkedin = ShareOnLinkedin;
var ShareOnTwitter = function ShareOnTwitter(props) {
  var link = props.link;
  return link ? /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "twitter-share",
    className: props.className,
    rel: "noreferrer",
    target: "_blank",
    href: "https://twitter.com/intent/tweet?url=".concat(link)
  }, props.children || 'Share on Twitter') : /*#__PURE__*/_react["default"].createElement(InvalidLink, null);
};
exports.ShareOnTwitter = ShareOnTwitter;
var ShareOnGmail = function ShareOnGmail(props) {
  var link = props.link;
  return link ? /*#__PURE__*/_react["default"].createElement("a", {
    "data-testid": "gmail-share",
    className: props.className,
    rel: "noreferrer",
    target: "_blank",
    href: "https://mail.google.com/mail/u/0/?view=cm&to&body=".concat(link)
  }, props.children || 'Share on Gmail') : /*#__PURE__*/_react["default"].createElement(InvalidLink, null);
};
exports.ShareOnGmail = ShareOnGmail;
var defaultProps = {
  link: undefined,
  className: ''
};
ShareOnFacebook.defaultProps = defaultProps;
ShareOnLinkedin.defaultProps = defaultProps;
ShareOnTwitter.defaultProps = defaultProps;
ShareOnGmail.defaultProps = defaultProps;